import { createSlice } from '@reduxjs/toolkit';
import initialState from './state';
import reducers from './reducer';

const webhookLogsSlice = createSlice({
  initialState,
  reducers,
  name: 'webhookLogs',
});

export const { setFilters, setOptions } = webhookLogsSlice.actions;
export default webhookLogsSlice.reducer;
